// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  height: 100%;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: blue;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


#root {
  height: 100%;
}


.detail-panel-div {
  max-height: 350px;
  overflow: auto;
  padding: 10px 70px;
  margin: 5px 20px;
  border: 1px solid black;
  border-radius: 4px;
}

#root .css-1arijsr-MuiSnackbar-root, .MuiSnackbar-anchorOriginTopRight:nth-child(2) {
  top: 90px !important;
  right: 90px !important;
}

@media (min-width: 600px)
.css-1arijsr-MuiSnackbar-root {
    top: 24px;
    right: 24px;
    left: auto;
}

.error-msg{
  color: red;
  font-size: 18px;
}

.error-circle{
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  text-align: center;
  padding: 3px 3px;
  margin-left: 5px;
  font-size: 12px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,YAAY;AACd;;;AAGA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;IAEI,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".App {\n  text-align: center;\n  height: 100%;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: blue;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n#root {\n  height: 100%;\n}\n\n\n.detail-panel-div {\n  max-height: 350px;\n  overflow: auto;\n  padding: 10px 70px;\n  margin: 5px 20px;\n  border: 1px solid black;\n  border-radius: 4px;\n}\n\n#root .css-1arijsr-MuiSnackbar-root, .MuiSnackbar-anchorOriginTopRight:nth-child(2) {\n  top: 90px !important;\n  right: 90px !important;\n}\n\n@media (min-width: 600px)\n.css-1arijsr-MuiSnackbar-root {\n    top: 24px;\n    right: 24px;\n    left: auto;\n}\n\n.error-msg{\n  color: red;\n  font-size: 18px;\n}\n\n.error-circle{\n  background-color: red;\n  color: white;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  text-align: center;\n  padding: 3px 3px;\n  margin-left: 5px;\n  font-size: 12px;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
